// A client created with responseType "arraybuffer" gets its error bodies as bytes too, so the server's
// error list has to be parsed before it can be read. A body that is not JSON is treated as no body.
export const decodeErrorBody = (data: unknown): unknown => {
  if (!(data instanceof ArrayBuffer)) {
    return data;
  }

  try {
    return JSON.parse(new TextDecoder().decode(data));
  } catch {
    return undefined;
  }
};
